// extracted by mini-css-extract-plugin
export default {"dot":"ActiveDot_dot__Zh-bu","active":"ActiveDot_active__FSJ6p","inactive":"ActiveDot_inactive__XePdt"};